<div class="d-flex flex-row">
    <div class="login-component" style="width: 550px;">
        <div class="row">
            <div class="col">
                <h1>Zarejestruj się</h1>
            </div>
        </div>
        <div class="row" style="margin-top:30px;">
            <div class="col">
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                    <mat-form-field appearance="outline" style="width:100%;">
                        <mat-label>Imię</mat-label>
                        <input matInput type="text" placeholder="Imię" required [errorStateMatcher]="matcher" formControlName="name">
                        @if (registerForm.get('name')?.hasError('required')) {
                          <mat-error>Proszę wprowadzić imię</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="width:100%;">
                        <mat-label>Nazwisko</mat-label>
                        <input matInput type="text" placeholder="Nazwisko" required [errorStateMatcher]="matcher" formControlName="surname">
                        @if (registerForm.get('name')?.hasError('required')) {
                          <mat-error>Proszę wprowadzić nazwisko</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline"  style="width:100%;">
                        <mat-label>Hasło</mat-label>
                        <input matInput type="password" [errorStateMatcher]="matcher" placeholder="Hasło" formControlName="password" required>
                        @if (registerForm.get('password')?.hasError('required')) {
                            <mat-error>Proszę wprowadzić hasło</mat-error>
                        } @else if (registerForm.get('password')?.hasError('minlength')) {
                            <mat-error>Długość hasła to minimum 8 znaków</mat-error>
                        } @else if (!registerForm.get('password')?.errors?.['passwordStrength'].hasUpperCase) {
                            <mat-error>Hasło musi zawierać wielką literę</mat-error>
                        } @else if (!registerForm.get('password')?.errors?.['passwordStrength'].hasLowerCase) {
                            <mat-error>Hasło musi zawierać małą literę</mat-error>
                        } @else if (!registerForm.get('password')?.errors?.['passwordStrength'].hasNumber) {
                            <mat-error>Hasło musi zawierać cyfrę</mat-error>
                        } @else if (!registerForm.get('password')?.errors?.['passwordStrength'].hasSpecialChar) {
                            <mat-error>Hasło musi zawierać znak specjalny</mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field appearance="outline"  style="width:100%;">
                        <mat-label>Powierdź hasło</mat-label>
                        <input matInput type="password" [errorStateMatcher]="matcher" placeholder="Potwierdź hasło" formControlName="password_confirm" required>
                        @if (registerForm.get('password_confirm')?.hasError('required')) {
                            <mat-error>Proszę wprowadzić  hasło</mat-error>
                        }
                        @else if (registerForm.errors?.['passwordMatch']) {
                            <mat-error>Hasła muszą być takie same.</mat-error>
                        }
                      </mat-form-field>
                      <mat-checkbox formControlName="acceptTerms">akceptuję Regulamin i Politykę prywatności</mat-checkbox>
                      @if (registerForm.get('acceptTerms')?.hasError('requiredTrue')) {
                            <mat-error>Akceptuj regulamin i politykę prywatności</mat-error>
                        }
                      <!-- TODO!! RodoLink -->
                      <div class="button">
                        <button style="width:100%;" type="submit" mat-flat-button color="tertiary" appearance="outline" [disabled]="!registerForm.valid">Zarejestruj</button>
                      </div>
                </form>
            </div>
        </div>
        <div class="row" style="margin-top:30px;">
            <div class="col">
            </div>
        </div>
    </div>
    <div class="rekbot-img"></div>
</div>